import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "file-bend, document" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M13.25 4.23895V10.2344H19.2501M5.25 3.73438H13.25L19.75 10.2344V22.2344H5.25V3.73438Z",
        stroke: "#007AFF",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }